
import ActivityModal from "@/views/user/modal/ActivityModal.vue";
import {
  defineComponent,
  ref,
  shallowRef,
  onMounted,
  computed,
  nextTick,
} from "vue";
import { FormApi } from "@/services/api/Form.service";
import { IFormSections } from "@/interfaces/iForm";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import VZSideDrawer from "@/components/content/VZSideDrawer.vue";
import { FormatMethods, getMaxLengthErrorMessage } from "@/helpers/data-format";
import { usePagination } from "@/helpers/pagination";
import { ITabConfig } from "@/interfaces/iTabConfig";
import { IBulkDelete } from "@/interfaces/iPageModel";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { TranslationService } from "@/core/services/TranslationService";
import { IAddEditFormModel } from "@/interfaces/iAddEditFormModel";
import TemplatePreviewModal from "@/views/formBuilder/modal/TemplatePreviewModal.vue";
import { SectionDesignAPI } from "@/services/api/SectionDesign.service";
import { Modal } from "bootstrap";
import { DrawerComponent } from "@/assets/ts/components";
import VZDeleteModal from "@/components/content/VZDeleteModal.vue";
import * as Yup from "yup";
import { useToast } from "vue-toastification";
import {
  formSectionsTableBulkDelete,
  formSectionsTableFilters,
  formSectionsTableHeaders,
  SECTIONS_TABS,
} from "./dataTableOptions";
import { hasPermission } from "@/core/services/permission.service";
import VZModal from "@/components/content/VZModal.vue";
import { ICurrentUser } from "@/interfaces/iCurrentUser";
import store from "@/store";
import { IDataTableFilterOption } from "@/interfaces/iPageModel";
export default defineComponent({
  components: {
    Datatable,
    VZSideDrawer,
    VZDeleteModal,
    VZModal,
    TemplatePreviewModal,
    ActivityModal,
  },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const toast = useToast();
    const showDialog = ref<any>(false);
    const showDeleteDialog = ref<any>(false);
    const addMessage = t("pages.form.sectionAddedMessage");
    const editMessage = t("pages.form.sectionUpdatedMessage");
    const designNotAvailable = t("pages.form.designNotAvailable");
    const datatable = ref<null | HTMLFormElement>(null);
    const { page, total, rowsPerPage } = usePagination();
    const loading = ref(false);
    const defaultFilter = ref({ status: "ACTIVE" });
    const showSearch = true;
    const sideDrawerTitle = ref<string>("");
    const sideDrawerIcon = ref<string>("");
    const openDrawer = ref<boolean>(false);
    const tableData = ref<IFormSections[]>([]);
    const selectedForAction = ref<Partial<IFormSections>>({});
    const bulkDelete = ref<IBulkDelete>(formSectionsTableBulkDelete());
    const tableHeader = ref(formSectionsTableHeaders());
    const tableFilter = ref<Array<IDataTableFilterOption>>(
      formSectionsTableFilters()
    );
    const tabs = shallowRef<ITabConfig[]>(SECTIONS_TABS());
    const selectedTemplateId = ref<number>(0);
    const selectedTemplateName = ref<string>("");

    let permissionModel = ref<any>({
      read: "VYZOR:TEMPLATES:SECTIONS:READ",
      create: "VYZOR:TEMPLATES:SECTIONS:CREATE",
      delete: "VYZOR:TEMPLATES:SECTIONS:DELETE",
      update: "VYZOR:TEMPLATES:SECTIONS:UPDATE",
    });
    let formData = ref<IAddEditFormModel>({
      page: "sections",
      header: "Sections",
      edit: false,
      data: null,
      defaultValues: {
        status: "Active",
      },
      label: [
        { addHeader: t("pages.form.addSection") },
        { editHeader: t("pages.form.editSection") },
      ],
      validationSchema: Yup.object({
        name: Yup.string()
          .strict(true)
          .max(30, getMaxLengthErrorMessage(t("common.name"), 30))
          .required(t("common.name") + " " + t("common.isRequired"))
          .matches(/\S/, t("common.name") + " " + t("common.isRequired")),
        status: Yup.string().required(
          t("common.status") + " " + t("common.isRequired")
        ),
        startDate: Yup.date()
          .nullable()
          .required(t("common.startDate") + " " + t("common.isRequired")),
        endDate: Yup.date()
          .min(Yup.ref("startDate"), t("validation.greaterEndDate"))
          .nullable(),
      }),
      model: [
        {
          name: "name",
          label: t("common.name"),
          type: "text",
          required: true,
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "startDate",
          label: t("common.startDate"),
          type: "date",
          required: true,
          format: "DD-MM-YYYY",
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "endDate",
          label: t("common.endDate"),
          type: "date",
          required: false,
          format: "DD-MM-YYYY",
          showOnlyInEdit: false,
          disabled: false,
        },
        {
          name: "status",
          label: t("common.status"),
          type: "text",
          required: true,
          showOnlyInEdit: false,
          disabled: true,
          placeholder: "Please select status",
          options: [
            {
              label: t("common.active"),
              value: "ACTIVE",
            },
            {
              label: t("common.inactive"),
              value: "INACTIVE",
            },
          ],
        },
        // {
        //   name: "recordHistory",
        //   label: t("pages.form.recordHistory"),
        //   type: "checkbox",
        //   required: true,
        //   showOnlyInEdit: false,
        //   disabled: false,
        // },
      ],
    });
    const localPreference = ref({});
    const lockedBy = ref("");
    const format = computed(() => {
      return FormatMethods;
    });
    const currentUser = computed(() => {
      return store.getters.currentUser as ICurrentUser;
    });

    const tableRowClick = (item) => {
      tabs.value = tabs.value.map((tab) => {
        return { ...tab, props: { ...tab.props, data: item } };
      });
      sideDrawerTitle.value = item.name;
      sideDrawerIcon.value = "bi bi-list-stars";
      DrawerComponent?.getInstance("vz__drawer")?.toggle();
    };
    onMounted(async () => {
      setCurrentPageBreadcrumbs(t("pages.form.sections"), ["Home", "Sections"]);
      loading.value = true;
      // queryUpdate({
      //   ...defaultFilter.value,
      //   page: page.value - 1,
      //   size: rowsPerPage.value,
      // });
    });
    const queryUpdate = async (params?: any) => {
      try {
        loading.value = true;
        if (!params || !params.sort) {
          params = {
            ...params,
            sort: "createdDate,desc",
            startDate: params?.startDate === null ? [] : params?.startDate,
          };
        }
        localPreference.value = { ...params };
        const data = await FormApi.getInstance().getSectionList({
          ...params,
        });
        tableData.value = [...data.content];
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
      } finally {
        loading.value = false;
      }
    };

    const editSection = (item: IFormSections) => {
      if (datatable.value) {
        datatable.value.openAddEditModal = true;
      }
      formData.value.data = item;
      formData.value.edit = true;
    };

    const openDetailModal = async (formSection) => {
      try {
        const design = await SectionDesignAPI.getInstance().getFormDesign(
          formSection.webId + ""
        );
        const hasDesign =
          design &&
          (Array.isArray(design)
            ? design.length > 0
            : Object.keys(design).length > 0);
        if (!hasDesign) {
          toast.error(designNotAvailable);
          return;
        }

        selectedTemplateId.value = formSection.webId;
        selectedTemplateName.value = formSection.name;
        await nextTick();
        const modalEl = document.getElementById("templatePreviewModal");
        if (modalEl) {
          const bsModal = new Modal(modalEl as HTMLElement);
          bsModal.show();
        }
      } catch (err) {
        console.error(err);
      }
    };

    const submit = async (reqData) => {
      loading.value = true;
      reqData = formData.value.edit ? reqData : { ...reqData };
      let message = formData.value.edit ? editMessage : addMessage;
      await FormApi.getInstance()
        .addSections(reqData, formData.value.edit)
        .then(() => {
          toast.success(message);
          queryUpdate({
            ...localPreference.value,
            page: page.value - 1,
            size: rowsPerPage.value,
          });

          datatable.value?.VZFilter?.getLookupData();
        })
        .catch(() => {
          //
        })
        .finally(() => {
          loading.value = false;
        });
    };
    const refreshList = () => {
      showDeleteDialog.value = false;
      queryUpdate({ ...localPreference.value });
    };

    const deleteAlertMessage = (item: any) => {
      if (item.sectionAttached) {
        return `${t("validation.sectionAttachedToForm")} ${t(
          "validation.sureToDelete"
        )} ${item.name}?`;
      }

      return `${t("validation.sureToDelete")} ${item.name}?`;
    };
    const someOfSelectedSections = t("bulkDelete.someOfSelectedSections");
    const areYouSure = t("bulkDelete.areYouSureSections");
    const bulkDeleteTextForSections = ref<string | null>(null);
    const selectedItemsForDelete = (items: any) => {
      if (items.length) {
        const selectedSections = tableData.value.filter((section) =>
          items.includes(section.webId)
        );
        const attachedSections = selectedSections.filter(
          (section: any) => section.sectionAttached
        );
        const areSectionsAttached = attachedSections.length > 0;
        if (areSectionsAttached) {
          bulkDeleteTextForSections.value = `${someOfSelectedSections}<br/>${areYouSure}`;
        } else {
          bulkDeleteTextForSections.value = null;
        }
      } else {
        bulkDeleteTextForSections.value = null;
      }
    };
    return {
      bulkDelete,
      format,
      formData,
      tabs,
      tableData,
      tableHeader,
      tableFilter,
      sideDrawerTitle,
      sideDrawerIcon,
      showSearch,
      openDrawer,
      page,
      total,
      rowsPerPage,
      defaultFilter,
      loading,
      selectedForAction,
      editSection,
      tableRowClick,
      queryUpdate,
      submit,
      t,
      refreshList,
      permissionModel,
      hasPermission,
      currentUser,
      lockedBy,
      datatable,
      showDialog,
      showDeleteDialog,
      openDetailModal,
      selectedTemplateName,
      selectedTemplateId,
      deleteAlertMessage,
      bulkDeleteTextForSections,
      selectedItemsForDelete,
    };
  },
});
